<div class="minute-vote-detail card border-0 shadow-sm">
  <div class="card-body py-3 px-3">
    <h6 class="minute-vote-title mb-2">
      <i class="fa fa-check-square-o text-primary" aria-hidden="true"></i>
      {{ title }}
    </h6>

    <div *ngIf="loading" class="text-muted small py-2">
      <i class="fa fa-spinner fa-spin" aria-hidden="true"></i> Loading…
    </div>

    <div *ngIf="!loading && error" class="alert alert-danger py-2 px-2 small mb-2">{{ error }}</div>

    <ng-container *ngIf="!loading && summary">
      <div class="row text-center minute-vote-counts mb-2">
        <div class="col-4">
          <div class="minute-count-box approve">
            <div class="num">{{ summary.approveCount }}</div>
            <div class="lbl">Approve</div>
          </div>
        </div>
        <div class="col-4">
          <div class="minute-count-box reject">
            <div class="num">{{ summary.rejectCount }}</div>
            <div class="lbl">Reject</div>
          </div>
        </div>
        <div class="col-4">
          <div class="minute-count-box total">
            <div class="num">{{ summary.totalVotes }}</div>
            <div class="lbl">Total</div>
          </div>
        </div>
      </div>

      <div *ngIf="allowVoting" class="minute-vote-actions mb-2">
        <button type="button" class="btn btn-sm btn-success mr-1" (click)="submitVote('APPROVE')" [disabled]="votingLoading || !canCurrentUserVote()">
          Approve
        </button>
        <button type="button" class="btn btn-sm btn-danger mr-1" (click)="submitVote('REJECT')" [disabled]="votingLoading || !canCurrentUserVote()">
          Reject
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary" *ngIf="summary.userVote" (click)="retractVote()" [disabled]="votingLoading || !canCurrentUserVote()">
          Retract vote
        </button>
      </div>

      <div *ngIf="allowVoting" class="form-group mb-2">
        <label class="small text-muted mb-1">Comment (required if rejecting)</label>
        <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="rejectComment" [disabled]="!canCurrentUserVote()" placeholder="Optional for approve; required for reject"></textarea>
      </div>
      <div *ngIf="allowVoting && !canCurrentUserVote()" class="alert alert-warning py-1 px-2 small mb-2">
        You are currently not eligible to vote on these minutes.
      </div>

      <div *ngIf="votingLoading" class="small text-muted mb-2"><i class="fa fa-spinner fa-spin"></i> Saving…</div>

      <div *ngIf="summary.userVote" class="small text-muted mb-2">
        Your vote: <strong>{{ summary.userVote.voteType === 'APPROVE' ? 'Approve' : 'Reject' }}</strong>
        <span *ngIf="summary.userVote.votedAt"> · {{ summary.userVote.votedAt | date : 'medium' }}</span>
      </div>

      <button type="button" class="btn btn-link btn-sm p-0 mb-2" (click)="showBreakdown = !showBreakdown">
        {{ showBreakdown ? 'Hide' : 'Show' }} voter details
      </button>

      <div *ngIf="showBreakdown" class="minute-breakdown">
        <div *ngFor="let v of allVoters()" class="minute-breakdown-row">
          <div class="d-flex align-items-start">
            <div class="minute-avatar">{{ initials(v.userName) }}</div>
            <div class="flex-grow-1" style="min-width: 0">
              <div class="d-flex justify-content-between flex-wrap gap-1">
                <div>
                  <div class="font-weight-bold small">{{ v.userName }}</div>
                  <div class="small text-muted" *ngIf="v.userEmail">{{ v.userEmail }}</div>
                  <div class="small text-muted" *ngIf="v.votedAt">{{ v.votedAt | date : 'medium' }}</div>
                </div>
                <span class="badge" [ngClass]="v.voteLabel === 'Approve' ? 'badge-success' : 'badge-danger'">{{ v.voteLabel }}</span>
              </div>
              <div *ngIf="v.voteLabel === 'Reject' && v.comments" class="minute-reject-note mt-1">
                <strong class="d-block small text-uppercase">Comment</strong>
                {{ v.comments }}
              </div>
            </div>
          </div>
        </div>
        <p *ngIf="allVoters().length === 0" class="text-muted small mb-0">No votes yet.</p>
      </div>
    </ng-container>

    <div *ngIf="!loading && isAdmin" class="minute-admin-panel mb-2">
      <button type="button" class="btn btn-link btn-sm p-0" (click)="adminPanelOpen = !adminPanelOpen">
        {{ adminPanelOpen ? 'Hide' : 'Manage' }} voter eligibility
      </button>
      <div *ngIf="adminPanelOpen" class="minute-admin-body mt-2">
        <div *ngIf="meetingParticipants.length === 0" class="small text-muted">No meeting participants found.</div>
        <div *ngFor="let p of meetingParticipants" class="minute-admin-row">
          <label class="mb-0 d-flex align-items-start">
            <input type="checkbox" class="mr-2 mt-1" [checked]="isParticipantEligible(p.userId)" (change)="toggleParticipantEligibility(p.userId)">
            <span>
              <span class="d-block font-weight-bold small">{{ p.userName }} <span class="text-muted">({{ p.participantType }})</span></span>
              <span class="small text-muted" *ngIf="p.userEmail">{{ p.userEmail }}</span>
            </span>
          </label>
        </div>
        <button type="button" class="btn btn-sm btn-primary mt-2" (click)="saveEligibility()" [disabled]="adminSaving">
          <i *ngIf="adminSaving" class="fa fa-spinner fa-spin mr-1"></i>Save eligibility
        </button>
      </div>
    </div>
  </div>
</div>
